import { api, requestPage } from '@/shared/api/client';
import type { Modality } from '@/shared/api/resources';

import type {
  EngineCatalog,
  ParameterSetSummary,
  Simulation,
  SimulationRequest,
} from './types';

/**
 * Chamadas do simulador de regras de credito (ADR 0083).
 *
 * Ficam no proprio modulo para nao mexer nos arquivos centrais de recursos. A
 * simulacao nao grava nada: e um POST porque leva o pedido no corpo.
 */
export const creditSimulator = {
  catalog: (signal?: AbortSignal) =>
    api.get<EngineCatalog>('/api/v1/credit-engine/catalog', signal),
  parameterSets: (signal?: AbortSignal) =>
    api.get<ParameterSetSummary[]>('/api/v1/credit-engine/parameter-sets', signal),
  parameterSet: (id: string, signal?: AbortSignal) =>
    api.get<ParameterSetSummary>(`/api/v1/credit-engine/parameter-sets/${id}`, signal),
  /** Modalidades da empresa. Quem nao le o cadastro de produtos usa a referencia. */
  modalities: async (signal?: AbortSignal): Promise<Modality[]> =>
    (await requestPage<Modality>('/api/v1/modalities?limit=100', signal)).items,
  simulate: (body: SimulationRequest) =>
    api.post<Simulation>('/api/v1/credit-engine/simulations', body),
};
